import { useEffect, useRef, useState } from "react";
import { useRefinementList } from "react-instantsearch";
import { PLPFiltersTracking } from "../common/Tracking";
import { ControlledSearchBox } from "./ControlledSearchBox"
import { filterClickHandler } from "./filters-utils";

const CustomRefinementWithSearchable = (props) => {
  const {
    canToggleShowMore,
    isFromSearch,
    isShowingMore,
    items,
    refine,
    searchForItems,
    toggleShowMore,
  } = useRefinementList({ ...props, limit: 1000 });// fetch all the refinements since algolia gives exact of 1000 values limit
  const { searchable, searchablePlaceholder, showMore,filterType
  } = props;

  const [query, setQuery] = useState('');
  const previousQueryRef = useRef(query);
  const inputRef = useRef(null);

  useEffect(() => {
    if (previousQueryRef.current !== query) {
      previousQueryRef.current = query;
      searchForItems(query);
    }
  }, [query, searchForItems]);

  // function that places the refined items on top 
  const getRefinedItemsOnTop = () => [...items].sort((a, b) => {
    if (a.isRefined && !b.isRefined) {
      return -1;
    }
    else if (!a.isRefined && b.isRefined) {
      return 1;
    }
    //sort filters alphabetically
    return a.label.toLowerCase().localeCompare(b.label.toLowerCase())
  })

  return (
    <>
        {/* render the input to search the designers */}
        {searchable && (
            <ControlledSearchBox
            className="inner_searchbar"
              inputRef={inputRef}
              placeholder={searchablePlaceholder}
              isSearchStalled={false}
              onChange={(event) => {
                setQuery(event.currentTarget.value);
              }}
              value={query}
            />
        )}

        {/* handle UI when refinements label not matching the searched query */}
        {searchable && isFromSearch && items.length === 0 && (
          <div className="">No results.</div>
        )}

        {/* render the refinements */}
        {getRefinedItemsOnTop().map((item) => (
          <li
            key={item.value}
            className=""
            onClick={() => { filterClickHandler(item, refine, props.serverRender), PLPFiltersTracking(props.attribute==="vendor"&&"Designer",item.value,item.isRefined) }}
          >
            <div className="custom-checkbox">
              <input
                className=""
                type="checkbox"
                value={item.value}
                checked={item.isRefined}
                onChange={() => {
                  refine(item.value);
                  setQuery('');
                }}
              />
              <label className="">
                <span className="ais-RefinementList-count">{item.label}</span>
              </label>
            </div>
          </li>
        ))}

        {/*if refinements > 20, make the {showMore} prop as true to get the further list */}
        {showMore && (
          <button
            className=""
            disabled={!canToggleShowMore}
            onClick={toggleShowMore}
          >
            {isShowingMore ? 'Show less' : 'Show more'}
          </button>
        )}
    </>
  )

}

export default CustomRefinementWithSearchable;